<template>
  <div>
    <breadcrumb-list>
      <breadcrumb-link view="Home" label="Home" />
      <breadcrumb-link view="OrganizationDetail" :label="organization" />
      <breadcrumb-link
        view="ProviderUpdate"
        :params="{ id: provider.id }"
        :label="`Update ${provider.name}`"
        :active="true"
        v-if="!loading"
      />
    </breadcrumb-list>

    <ProviderUpdateForm v-if="!loading" :is-for-admin="false" :provider="provider"></ProviderUpdateForm>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ProviderUpdateForm from '../components/ProviderUpdateForm';
import request from '../request';

export default {
  name: 'ProviderUpdate',
  components: { ProviderUpdateForm },
  data() {
    return {
      loading: true,
      provider: null,
    };
  },
  computed: {
    ...mapGetters(['organization']),
  },
  beforeRouteEnter(to, from, next) {
    request
      .get(`/providers/${to.params.id}`)
      .then((resp) => next((vm) => vm.setData(resp.data.provider)))
      .catch(() => next({ name: 'NotFound' }));
  },
   methods: {
    setData(provider) {
      this.provider = provider;
      this.loading = false;
    },
  },
};
</script>
